import { Button, ButtonProps } from '@mui/material';

const ButtonWrapper: React.FC<ButtonProps> = ({ ...props }) => <Button {...props} />;

export default ButtonWrapper;
